import { useState } from "react";
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";
import { FaChevronLeft } from "react-icons/fa";
import { useSwipeable } from "react-swipeable";
import { isMobile } from "react-device-detect";
import React from "react";
import { TbArrowRightCircle } from "react-icons/tb";
import { CgArrowsExpandUpRight } from "react-icons/cg";

interface NeoSplitCarouselContainerProps {
    id: string;
    children: React.ReactElement<NeoSplitSlideProps> | React.ReactElement<NeoSplitSlideProps>[];
    onImageLoaded: () => void;
    onNavigate?: () => void;
}

export function NeoSplitCarouselContainer(props: NeoSplitCarouselContainerProps) {
    const [activeTab, setActiveTab] = useState(0);

    const changeTab = (direction = 1) => {
        // direction can either be 1 or -1
        let index: number = 0;

        if (activeTab === 0 && direction === -1) {
            index = 0;
        } else if (activeTab === React.Children.toArray(props.children).length - 1 && direction === 1) {
            // if the index exceeds the number of items, emit the onNavigate to parent.
            if (typeof props.onNavigate === "function") {
                props.onNavigate();
            }
        } else {
            index = activeTab + direction;
        }

        setActiveTab(index);

        showSlide(index);
    };

    const handlers = useSwipeable({
        onSwiped: (eventData) => {
            if (eventData.dir === "Left") {
                changeTab();
            } else if (eventData.dir === "Right") {
                changeTab(-1);
            }
        },
    });

    const onFirstImageLoad = () => {
        if (typeof props.onImageLoaded === "function") {
            props.onImageLoaded();
        }
    };

    const showSlide = (index = 1) => {
        //
        const mediaContainers = document.querySelectorAll(`#${props.id} .img-container img.banner-image,
        #${props.id} .video-container`);

        const translateOffset = index * -100;

        mediaContainers.forEach((element) => {
            (element as HTMLDivElement).style.transform = isMobile ? `translateX(${translateOffset}%)` : `translateY(${translateOffset}%)`;
        });

        // text contents
        const textContents = document.querySelectorAll(`#${props.id} .text-contents`);

        textContents.forEach((element) => {
            (element as HTMLDivElement).style.opacity = "0";
            (element as HTMLDivElement).style.display = "none";
        });
        // Make specific element show
        (textContents[index] as HTMLDivElement).style.opacity = "1";
        (textContents[index] as HTMLDivElement).style.display = "block";
    };
    /**
     * Re
     */
    function onNavigateBack() {
        changeTab(-1);
    }

    function onNavigate() {
        changeTab(1);
    }

    const childrenWithProps = React.Children.map(props.children, (child) => {
        if (React.isValidElement(child)) {
            return React.cloneElement(child, { onNavigateBack, onNavigate });
        }
        return child;
    });

    return (
        <section id={props.id} {...handlers} className={`overview-panel`}>
            <div className="img-container">
                {/*<Skeleton style={{zIndex: 9999 }} className="w-full h-full" />*/}

                {React.Children.map(props.children, (child, index) => {
                    if (React.isValidElement(child)) {
                        if (index === 0) {
                            return <img src={(child.props as any).imageUrl} className="banner-image" onLoad={onFirstImageLoad} alt="landing_image" />;
                        }
                        return <img src={(child.props as any).imageUrl} className="banner-image" alt="landing_image" />;
                    }
                    return child;
                })}
                <div className="img-container-footer">
                    <img src="/ATS_Global_Branding_Icon_White.png" alt="" className="h-[75px]" />
                    {/* <div className="first-col">
                        <a href="https://neoworlder.ai" target="_blank">
                            <img className="neo_ai_logo" src="/NeoAI%20Logo_Source_White.png" alt="neo_ai" />
                        </a>
                        <a href="https://worldercore.com" target="_blank">
                            <img className="worldercore_logo" src="/WorlderCore_Logo_Source_white.png" alt="neo_ai" />
                        </a>
                    </div>
                    <div className="second-col">
                        <a href="https://lootverse.com" target="_blank">
                            <img className="lootverse_logo" src="/Lootverse_Emblem_white.png" alt="lootverse" />
                        </a>
                    </div> */}
                </div>
            </div>

            <div className="text-container">
                {/* Containers for the right side scroll */}
                {childrenWithProps}
            </div>
        </section>
    );
}

interface NeoSplitSlideProps {
    imageUrl: string;
    children: any;
    theme?: "dark" | "light";
    hideBackBtn?: boolean;
    popupAction?: () => void;
    onNavigateBack?: () => void;
    onNavigate?: () => void;
    smButtonClass?: string;
    textContainerClassName?: string;
    textContainerStyle?: React.CSSProperties;
}
export function NeoSplitSlide(props: NeoSplitSlideProps) {
    const onNavigateBack = () => {
        if (typeof props.onNavigateBack === "function") {
            props.onNavigateBack();
        }
    };

    const onNavigatePage = () => {
        if (typeof props.onNavigate === "function") {
            props.onNavigate();
        }
    };
    return (
        <div style={props.textContainerStyle || {}} className={"text-contents text-context-no-inputs text-contents-647 " + props.textContainerClassName || ""}>
            <div className="feature-btn-section">
                {!props.hideBackBtn && (
                    <button className={`btn ${props.smButtonClass || ""}`} onClick={onNavigateBack}>
                        <BsChevronLeft className={`icon`} />
                    </button>
                )}
                {
                    typeof props.popupAction === "function" && (<button className={`btn ${props.smButtonClass || ""}`} onClick={props.popupAction}>
                        <CgArrowsExpandUpRight className="icon" />
                    </button>)
                }
                <button className={`btn ${props.smButtonClass || ""}`} onClick={onNavigatePage}>
                    <BsChevronRight className={`icon`} />
                </button>
            </div>
            {
                typeof props.popupAction === "function" && (<div className="banner-header">
                    <div className="expand-section text-center mb-6">
                        <button
                            className="feature-btn expand"
                            onClick={props.popupAction}
                        >
                            <CgArrowsExpandUpRight className="text-4xl inline" />
                        </button>
                    </div>
                </div>)}
            {props.children}
            <div className="mt-4 feature-btn-container">
                {!props.hideBackBtn && (
                    <button className="feature-btn prev" onClick={onNavigateBack}>
                        <FaChevronLeft className="icon" />
                        {/* <TbArrowLeftCircle className="icon"/> */}
                    </button>
                )}
                <button className="feature-btn" onClick={onNavigatePage}>
                    Next
                    <TbArrowRightCircle className="icon" />
                </button>
            </div>
        </div>
    );
}

export function NeoSplitBanner({ children, className = "" }) {
    return <div className={"banner-header " + className}>{children}</div>;
}

export function NeoSplitBannerTitle({ children, className = "" }) {
    return <h1 className={"title " + className}>{children}</h1>;
}

export function NeoSplitBannerSubtitle({ children, className = "" }) {
    return <h1 className={"subtitle " + className}>{children}</h1>;
}
